import { render, staticRenderFns } from "./BaseScrollTop.vue?vue&type=template&id=12aa3ab2"
import script from "./BaseScrollTop.vue?vue&type=script&lang=js"
export * from "./BaseScrollTop.vue?vue&type=script&lang=js"
import style0 from "./BaseScrollTop.vue?vue&type=style&index=0&id=12aa3ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports